import { useEffect, useState } from "react";
import ResizeObserver from "resize-observer-polyfill";

// https://stackoverflow.com/questions/64034706/responsive-d3-charts-in-react-resizeobserver-or-the-viewbox-attribute
// https://github.com/muratkemaldar/using-react-hooks-with-d3/blob/06-components-responsive/src/BarChart.js
export const useResizeObserver = (ref: React.RefObject<Element | null>) => {
  const [dimensions, setDimensions] = useState(null);
  useEffect(() => {
    const observeTarget = ref.current;
    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        setDimensions(entry.contentRect);
      });
    });
    if (observeTarget) {
      resizeObserver.observe(observeTarget);
    }
    return () => {
      if (observeTarget) {
        resizeObserver.unobserve(observeTarget);
      }
    };
  }, [ref]);
  return dimensions;
};
